import React from "react"
import { FormattedMessage } from "react-intl";
import { scheduleScreenMessages } from "../../messages";
import './ScheduledTag.scss';

export const ScheduledTag = ({shadow = true}) => 
    <span className={`selected-tag${shadow ? ' shadow' : ''}`}>
        <FormattedMessage {...scheduleScreenMessages.current_tag} />
    </span>
